export default __webpack_public_path__ + "static/media/gif1.9a0ce817.gif";